export default __webpack_public_path__ + "static/media/Protection.97a5a928.png";